import Layout from "Layout";
import React from "react";
import HorizontalCard from "components/HorizontalCard";
import DetailQanun from "Layout/DetailQanun";
import ImLaw from 'assets/images/im-laws1.jpg'
import { useState } from "react";
import { useCallback } from "react";
import { getQanun } from "services/apiRoutes";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

export default function QanunGampong() {
  const {slug} = useParams();
  const [qanun,setQanun]=useState();

  const qanunAPI = useCallback(async () =>{
    const res = await getQanun(slug);
    if (res.error) {
      return res.message
    }else{
      const {data}= res.data;
      setQanun(data);
    }
  },[slug])


  useEffect(() => {
    qanunAPI();
  }, [qanunAPI]);

  return (
    <Layout>
      <div className="px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:text-7xl">Qanun Gampong</h1>
        <div className="space-y-24 wrapperCad my-[80px]">
          <HorizontalCard
            desc="Qanun Gampong Geulanggang Teungoh"
            title="Qanun Gampong Geulanggang Teungoh"
            img={ImLaw}
          />
        </div>
        <div className="p-4 space-y-5 mb-36 wrapperDescBatas rounded-2xl bg-blurBorder xl:p-7 ">
          <DetailQanun qanun={qanun} />
        </div>
      </div>
    </Layout>
  );
}
